import { paramCase } from 'change-case';
export default {
  getStylesheet(stylemap, selector) {
    let stylesheet = '';
    for (const breakpoint in stylemap) {
      const propertyStyles = this.getStateVariantStyles(
        stylemap[breakpoint],
        selector
      );
      if (propertyStyles && breakpoint === 'all') {
        stylesheet += `
${propertyStyles}`;
      } else if (propertyStyles) {
        stylesheet += `
@media ${breakpoint} {
  ${propertyStyles}
}`;
      }
    }
    return stylesheet;
  },
  getStateVariantStyles(variants, selector) {
    let styles = '';
    for (const variant in variants) {
      const propertyStyles = this.getPropertyStyles(variants[variant]);
      if (propertyStyles && variant === 'none') {
        styles += `
  ${selector} {
    ${propertyStyles}
  }`;
      } else if (propertyStyles) {
        styles += `
  ${selector}:${variant} {
    ${propertyStyles}
  }`;
      }
    }
    return styles;
  },
  getPropertyStyles(properties) {
    let styles = '';
    for (const property in properties) {
      if (properties[property] !== null)
        styles += `
      ${paramCase(property)}: ${properties[property]};`;
    }
    return styles;
  }
};
